var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class FieldMetadata {
  constructor(_data) {
    /**
     */
    __publicField(this, "IsRequired");
    /**
     */
    __publicField(this, "Name");
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof FieldMetadata
     */
    __publicField(this, "$type", "V1.GenerationConfiguration.FieldMetadata");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.IsRequired = _data["IsRequired"];
      this.Name = _data["Name"];
      this.Type = FieldMetadataType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["IsRequired"] = this.IsRequired;
    _data["Name"] = this.Name;
    _data["Type"] = FieldMetadataType[this.Type];
    return _data;
  }
}
export var FieldMetadataType = /* @__PURE__ */ ((FieldMetadataType2) => {
  FieldMetadataType2["Date"] = "Date";
  FieldMetadataType2["String"] = "String";
  FieldMetadataType2["Currency"] = "Currency";
  FieldMetadataType2["Number"] = "Number";
  FieldMetadataType2["CountryCode"] = "CountryCode";
  return FieldMetadataType2;
})(FieldMetadataType || {});
